module.exports = __webpack_public_path__ + "static/media/lobo_kit_items.df5dc182.png";